import React from 'react';

import { Link } from '@qality/common-components/src/atoms/Link';
import { Breadcrumbs } from '@qality/common-components/src/molecules/Breadcrumbs';
import { Issue } from '@qality/common-components/src/molecules/Issue';
import { TestType } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';

type Props = {
  testCaseName: string;
  testCaseIssueKey?: string;
  testCaseIssueTypeIcon?: string;
  testCaseUrl: string;
  testCycleName?: string;
  testCycleUrl?: string;
  testType: TestType;
};

function TestExecutionBreadcrumbs({
  testCaseIssueKey,
  testCaseName,
  testCaseIssueTypeIcon,
  testCaseUrl,
  testCycleName,
  testCycleUrl,
  testType,
}: Props): JSX.Element {
  return (
    <Breadcrumbs>
      {testCycleName && (
        <Breadcrumbs.Item>
          <Link
            onClick={() => {
              StorageOfUniqueServices.get('AP').navigator.go('site', {
                absoluteUrl: testCycleUrl,
              });
            }}
            gray
          >
            {testCycleName}
          </Link>
        </Breadcrumbs.Item>
      )}
      <Breadcrumbs.Item>
        <Breadcrumbs.Item>
          <Issue
            title={testCaseName}
            issueKey={testCaseIssueKey}
            issueLink={testCaseUrl}
            testTypeProps={{
              testType: testType,
              isReadOnly: true,
              isIconOnly: true,
              isLoading: !testType,
              style: { paddingRight: '4px', paddingTop: '4px' },
            }}
          />
        </Breadcrumbs.Item>
      </Breadcrumbs.Item>
    </Breadcrumbs>
  );
}

export default TestExecutionBreadcrumbs;
